var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG3Da(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1024",
    style: {
      enableBackground: "new 0 0 1280 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8BB15;}\n\t.st1{fill:#4285F4;}\n\t.st2{fill:none;stroke:#000000;stroke-width:4.7176;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#E94435;}\n\t.st5{fill:#34A751;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M684.9,501.5c-6.2-8.9-17.3-14-32.8-15.4c-4.9-0.4-9.3-0.5-13.4-0.3c6,3,10.9,7.1,14.4,12.2 c6,8.5,7.1,18.1,7,25.2h30.6C690.9,517.1,689.9,508.7,684.9,501.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M654.6,580.9c10.7,10.8,13.3,24.8,13.8,33.5h30.6c-0.5-7.8-2.8-20-12-29.1c-8.6-8.5-21.3-12.8-38.1-12.6 c-1.6,0.2-3.2,0.4-4.9,0.5C648.1,575.3,651.6,577.9,654.6,580.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.7,479.8c-54.7-4.8-61.4,31.8-61.5,32.2l6.2,1c0.2-1.3,5.8-30.2,52.1-27.2c3.6-1.9,7.9-3.5,12.9-4.6 C622.4,480.6,619.1,480.2,615.7,479.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.1,570.4l0,3.1c4.7,0,9.1-0.3,13.1-0.8c-4,0-8.2,0.3-12.7,0.8L599.1,570.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.5,564.9l7.1,1.7c22-10.8,25-30.4,25.3-33.3c0.1-0.6,0.4-1.9,0.7-3.8h-1.3c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1 h1.9c0.2-7.1-1-16.7-7-25.2c-3.6-5.1-8.4-9.2-14.4-12.2c-5,0.2-9.5,0.9-13.4,1.9c10.3,2.4,17.9,7,22.6,13.8 c9.2,13.1,4.8,30.2,4.8,30.4l-0.1,0.6c-0.1,1.3-2.5,28.8-40.8,34c5,0,9.7,0.3,14,0.9L626.5,564.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.2,573.2c1.7-0.1,3.3-0.3,4.9-0.5c-1.8,0-3.6,0.1-5.4,0.2C643.8,573,644,573.1,644.2,573.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.5,485.9c-18.3,9.5-21.3,25.9-21.3,26.1l6.2,1c0.2-1,3.7-19.2,27.9-25.4c-3.1-0.7-6.5-1.3-10.2-1.6 C614.2,486,613.4,486,612.5,485.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.1,486.1c15.6,1.4,26.6,6.6,32.8,15.4c5,7.2,6,15.5,5.8,21.7h2.2c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1h-2.8 c-0.2,1.5-0.5,2.4-0.5,2.4l-0.1,0.6c-0.1,1.3-2.5,28.8-40.8,34c6.6-0.1,12.7,0.5,18.2,1.7c25.1-10.3,28.5-31.8,28.8-34.9 c0.6-2.5,4.6-20.6-5.7-35.3c-7.3-10.5-19.9-16.6-37.4-18.1c-10.9-1-19.8-0.3-27.2,1.4c4.9,1.1,9.4,2.6,13.3,4.5 C642.8,485.6,647.2,485.7,652.1,486.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.4,481.3c-5,1.1-9.2,2.8-12.9,4.6c0.9,0.1,1.7,0.1,2.6,0.2c3.6,0.3,7,0.9,10.2,1.6c3.9-1,8.3-1.7,13.4-1.9 C634.8,483.8,630.4,482.3,625.4,481.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667,568.2c-5,2.1-11,3.7-17.9,4.6c16.7-0.1,29.5,4.1,38.1,12.6c9.1,9.1,11.5,21.3,12,29.1h2c1.7,0,3.1,1.4,3.1,3.1 c0,1.7-1.4,3.1-3.1,3.1h-2c0,0.8-0.1,1.2-0.1,1.3c-1,14-7.8,24.9-20,32.3c-9.4,5.7-18.6,7.1-18.7,7.2c-7.1,0.9-13.6,1.1-19.4,0.5 c11.8-5.9,25.8-17.5,27.3-39.4c0-0.2,0.1-0.8,0.2-1.9h-2c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1h2c-0.5-8.7-3.1-22.8-13.8-33.5 c-3.1-3.1-6.6-5.6-10.5-7.7c-2.6,0.2-5.3,0.3-8.1,0.3l0-6.3c4.6,0,8.9-0.3,12.7-0.8c-4,0-8.2,0.3-12.5,0.8l-2.7-0.6 c-5.7,2.8-12.8,5-21.4,6.1c16.7-0.1,29.5,4.1,38,12.6c14.3,14.3,11.9,36.3,11.9,36.7c-1,14-7.8,24.9-20,32.3 c-4.6,2.8-9.1,4.5-12.5,5.6c-32.9-9.1-40-41.3-40.3-43l-0.5-2.5h-43.4l0.8,3.8c0.1,0.6,11,50.4,65.1,50.4c4.1,0,8.5-0.3,13.1-0.9 c0.1,0,2.2-0.3,5.4-1.3c8.8,2.2,19.3,2.9,31.6,1.3c0.4-0.1,41.3-6.6,44.1-45.1c0.1-1,2.8-25.2-13.7-41.7 C685.3,574.6,677,570.3,667,568.2z M553.2,620.7h30.4c2.2,7.5,10.7,30.1,34,41.4C571.4,665.6,556.9,632.3,553.2,620.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.8,566.5c-4.2,0-8.5,0.3-13.1,0.9l0.4,3.1l0-3.1C603.7,567.3,608,567,611.8,566.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.5,564.9l-0.6,2.5c-4.4-0.7-9.1-1-14-0.9c-3.9,0.5-8.1,0.8-12.7,0.8l0,3.1l0.4,3.1c4.5-0.5,8.7-0.8,12.7-0.8 c8.6-1.1,15.6-3.3,21.4-6.1L626.5,564.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.1,567.3l0,6.3c2.8,0,5.5-0.1,8.1-0.3c-0.2-0.1-0.4-0.2-0.6-0.3c1.9-0.1,3.7-0.2,5.4-0.2c7-0.9,12.9-2.5,17.9-4.6 c-5.5-1.2-11.6-1.8-18.2-1.7C644.9,567,640.7,567.3,636.1,567.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.7,523.2h-30.6c-0.1,2.5-0.3,4.6-0.5,6.3h30.6C690.4,528,690.7,525.8,690.7,523.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.2,523.2c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h1.3c0.3-1.7,0.5-3.8,0.5-6.3H658.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.9,529.5c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1h-2.2c-0.1,2.6-0.3,4.7-0.6,6.3H692.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.5,620.7h30.6c0.1-1.3,0.1-3.5,0-6.3h-30.6C668.6,617.1,668.5,619.3,668.5,620.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.1,620.7h2c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1h-2C699.2,617.2,699.2,619.4,699.1,620.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.5,614.4h-2c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h2C668.5,619.3,668.6,617.1,668.5,614.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M763.9,522.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M763.9,610.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st3",
    d: "M267.7,369.7c-46.6,16-86.4,50.9-108.5,94.9c-7.7,15.2-13.3,31.4-16.6,48.1 c-8.5,41.6-2.6,85.8,16.6,123.8c12.4,24.8,30.3,46.7,52,63.9c20.5,16.3,44.3,28.3,69.6,35.1c31.8,8.6,65.8,8.4,98,1.1 c29-6.7,56.5-20.6,78.3-40.7c23.1-21.3,39.7-49.3,48.4-79.4c9.5-32.9,10.8-67.9,4.8-101.6c-60,0-120,0-180.2,0 c0,24.9,0,49.8,0,74.7c34.7,0,69.6,0,104.3,0c-4.1,23.9-18.2,45.7-38.4,59.2c-12.6,8.5-27.1,14-42.1,16.6 c-15.1,2.6-30.6,2.9-45.7-0.1c-15.3-3-29.9-9.4-42.7-18.4c-20.4-14.2-35.9-35.3-43.8-58.7c-8.1-23.9-8.3-50.6,0-74.5 c5.7-16.8,15.2-32.5,27.8-45.1c15.4-15.9,35.5-27.1,57.1-31.7c18.5-4,38-3.2,56.2,2.2c15.4,4.7,29.6,13.1,41.3,24.2 c11.8-11.7,23.5-23.5,35.3-35.1c6.1-6.3,12.6-12.3,18.7-18.9c-17.8-16.5-38.8-29.8-61.6-38.1C355.5,355.7,309.1,355.4,267.7,369.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st4",
    d: "M267.7,369.7c41.4-14.4,87.8-14,128.9,1.2c22.8,8.4,43.7,21.7,61.6,38.1 c-6,6.4-12.4,12.5-18.7,18.9c-11.8,11.7-23.5,23.5-35.3,35.1c-11.7-11.1-25.8-19.6-41.3-24.2c-18.1-5.5-37.6-6.2-56.2-2.2 c-21.7,4.6-41.7,16-57.1,31.7c-12.5,12.6-22.1,28.3-27.8,45.1c-20.9-16.2-41.8-32.5-62.7-48.7 C181.3,420.6,221.1,385.7,267.7,369.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st0",
    d: "M142.6,512.8c3.3-16.7,9-32.9,16.6-48.1c20.9,16.2,41.8,32.5,62.7,48.7 c-8.3,23.9-8.1,50.6,0,74.5c-20.9,16.2-41.8,32.5-62.7,48.7C140.1,598.8,134.2,554.4,142.6,512.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st1",
    d: "M330.3,514.7c60,0,120,0,180.2,0c6,33.7,4.7,68.7-4.8,101.6c-8.8,30.1-25.3,58.2-48.4,79.4 c-20.3-15.8-40.6-31.5-60.8-47.3c20.1-13.4,34.3-35.3,38.4-59.2c-34.7,0-69.6,0-104.3,0C330.2,564.6,330.3,539.7,330.3,514.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st5",
    d: "M159.3,636.6c20.9-16.2,41.8-32.5,62.7-48.7c7.9,23.6,23.5,44.5,43.8,58.7 c12.8,9,27.3,15.3,42.7,18.4c15,3,30.6,2.7,45.7,0.1s29.5-8.1,42.1-16.6c20.3,15.8,40.6,31.5,60.8,47.3 c-21.9,20.3-49.3,34.1-78.3,40.7c-32,7.3-66,7.5-98-1.1c-25.3-6.7-49.1-18.8-69.6-35.1C189.6,683.2,171.7,661.3,159.3,636.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1110.6,590.5 1071.9,494.2 1058,528.5 1082.9,590.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "995.7,596.8 976,645.3 1003.6,645.3 1023.4,596.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1076.1,590.5 1082.9,590.5 1058,528.5 1054.6,536.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "993.4,596.8 993.4,590.5 998.3,590.5 1037.5,494.2 1051.2,528.5 1054.6,520.1 1037.5,477.5 967.8,648.7  973.6,651.1 976,645.3 972.6,645.3 976,645.3 995.7,596.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1100.4,650.9 1106.3,648.6 1085.4,596.8 1078.7,596.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1054.6,520.1 1058,528.5 1071.9,494.2 1110.6,590.5 1113.8,590.5 1113.8,596.8 1113.1,596.8 1134.9,650.9  1140.7,648.6 1072,477.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1003.6,645.3 1007,645.3 1003.6,645.3 1002.2,648.7 1008.1,651.1 1030.2,596.8 1023.4,596.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1051.2,528.5 1025.9,590.5 1032.7,590.5 1054.6,536.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1054.6,536.9 1058,528.5 1054.6,520.1 1051.2,528.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1082.9,590.5 1085.4,596.8 1113.1,596.8 1110.6,590.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1032.7,590.5 1030.2,596.8 1078.7,596.8 1076.1,590.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "995.7,596.8 1023.4,596.8 1025.9,590.5 998.3,590.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "993.4,590.5 993.4,596.8 995.7,596.8 998.3,590.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1076.1,590.5 1078.7,596.8 1085.4,596.8 1082.9,590.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1025.9,590.5 1023.4,596.8 1030.2,596.8 1032.7,590.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1113.8,590.5 1110.6,590.5 1113.1,596.8 1113.8,596.8  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 763.9,
    y: 519.7,
    width: 4.4,
    height: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 763.9,
    y: 607.6,
    width: 4.4,
    height: 6.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 762.1,
    y: 613.9,
    className: "st0",
    width: 27.6,
    height: 36.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 762.1,
    y: 526,
    className: "st4",
    width: 27.6,
    height: 81.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M892.1,525.1c7,13.2,10.4,28.3,10.4,45.3c0,17-3.5,32-10.4,45.3c-7,13.2-16.7,23.5-29.3,30.9 c-2.6,1.6-5.4,2.9-8.2,4.1c15-0.1,28.2-3.5,39.6-10.2c11.5-6.8,20.4-16.3,26.8-28.4s9.5-26,9.5-41.7c0-15.7-3.2-29.6-9.5-41.7 c-6.3-12.1-15.3-21.5-26.8-28.4c-11.3-6.7-24.5-10.1-39.6-10.2c2.8,1.2,5.5,2.6,8.2,4.1C875.4,501.6,885.1,511.9,892.1,525.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.1,490c15.3,0,28.8,3.4,40.3,10.3c8.5,5,15.6,11.5,21.2,19.4h6.4v6.3h-2.3c0.5,0.9,1,1.7,1.5,2.6 c6.3,12.1,9.5,26,9.5,41.7c0,13.8-2.5,26.3-7.4,37.3h1.8v6.3h-5c-6.3,11.2-14.8,20-25.7,26.5c-11.5,6.8-24.9,10.3-40.3,10.3h33.7 c0.2,0,0.5,0,0.7,0c2.8-1.2,5.5-2.6,8.2-4.1c12.6-7.4,22.4-17.7,29.3-30.9c7-13.2,10.4-28.3,10.4-45.3c0-17-3.5-32-10.4-45.3 c-7-13.2-16.7-23.5-29.3-30.9c-2.6-1.5-5.4-2.9-8.2-4.1c-0.2,0-0.5,0-0.7,0L820.1,490L820.1,490z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "762.1,650.7 762.1,613.9 757.6,613.9 757.6,607.6 762.1,607.6 762.1,526 757.6,526 757.6,519.7 762.1,519.7  762.1,490 789.7,490 789.7,483.1 755.9,483.1 755.9,657.7 789.7,657.7 789.7,650.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.7,
    y: 490,
    width: 6.1,
    height: 29.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.7,
    y: 613.9,
    width: 6.1,
    height: 36.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.5,494.2c-12.6-7.4-27.1-11.1-43.5-11.1h-33.7c13,0,24.8,2.4,35.4,7c15,0.1,28.2,3.5,39.6,10.2 c11.5,6.8,20.4,16.3,26.8,28.4c6.3,12.1,9.5,26,9.5,41.7c0,15.7-3.2,29.6-9.5,41.7c-6.3,12.1-15.3,21.5-26.8,28.4 c-11.3,6.7-24.5,10.1-39.6,10.2c-10.6,4.6-22.4,7-35.4,7H853c16.4,0,30.9-3.7,43.5-11.1c12.6-7.4,22.4-17.7,29.3-30.9 c7-13.2,10.4-28.3,10.4-45.3c0-17-3.5-32-10.4-45.3C918.8,511.9,909.1,501.6,896.5,494.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.7,
    y: 526,
    width: 6.1,
    height: 81.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.8,490h24.3h33.7c0.2,0,0.5,0,0.7,0c-10.6-4.6-22.4-7-35.4-7h-29.5v7H795.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.9,650.7h-33.7h-24.3h-6.1v7h29.5c13,0,24.8-2.3,35.4-7C854.3,650.7,854.1,650.7,853.9,650.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.8,526h89.9c-1.3-2.2-2.6-4.3-4-6.3h-85.8L795.8,526L795.8,526z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 756.8,
    y: 519.7,
    width: 32.9,
    height: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888,526v-6.3h-6.4c1.4,2,2.8,4.1,4,6.3H888z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.7,
    y: 519.7,
    width: 6.1,
    height: 6.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 757.6,
    y: 607.6,
    width: 32,
    height: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.8,613.9h90.3c0.3-0.6,0.7-1.2,1-1.8c0.8-1.5,1.5-2.9,2.2-4.5h-93.5L795.8,613.9L795.8,613.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.1,613.9h5v-6.3h-1.8c-0.7,1.5-1.4,3-2.2,4.5C886.8,612.7,886.5,613.3,886.1,613.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789.7,
    y: 607.6,
    width: 6.1,
    height: 6.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG3Da);
export default __webpack_public_path__ + "static/media/G3DA.6c2950447476d4af09914dacd9fa4704.svg";
export { ForwardRef as ReactComponent };